import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent } from '@mui/material';
import { MODERN_COLORS, MODERN_RADIUS, MODERN_SHADOWS } from './tokens';

export const ModernFilterCard = ({ children, sx = {}, contentSx = {} }) => {
  return (
    <Card
      sx={{
        mb: 2,
        boxShadow: MODERN_SHADOWS.card,
        borderRadius: MODERN_RADIUS.card,
        border: `1.5px solid ${MODERN_COLORS.borderLight}`,
        bgcolor: MODERN_COLORS.bgCard,
        ...sx,
      }}
    >
      <CardContent
        sx={{
          p: { xs: 1.5, md: 2 },
          '&:last-child': { pb: { xs: 1.5, md: 2 } },
          ...contentSx,
        }}
      >
        {children}
      </CardContent>
    </Card>
  );
};

ModernFilterCard.propTypes = {
  children: PropTypes.node.isRequired,
  sx: PropTypes.object,
  contentSx: PropTypes.object,
};

export default ModernFilterCard;
